import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  FormControl,
  FormErrorMessage,
  Input,
  Link,
  Stack,
  Text
} from '@chakra-ui/react'
import { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Link as NavLink, useHistory } from 'react-router-dom'
import { forgotPassword } from '../../redux/storeConfig/slices/slice.auth'
import { validators } from '../../utility/Utils'

export default function ForgotPasswordForm() {
  /** @type {import('../../redux/storeConfig/slices/slice.auth/auth.types').AuthSlice} */
  const { status, task, errors } = useSelector(state => state.auth)
  const dispatch = useDispatch()

  const history = useHistory()

  const { register, handleSubmit, formState, watch } = useForm({ mode: 'onSubmit' })

  const email = watch('email')

  useEffect(() => {
    if (task === 'forgotPassword' && status === 'succeeded')
      history.push({ pathname: '/forgot_password', search: '?reset_sent=true' })
  }, [history, status, task])

  const onSubmit = useCallback(
    async data => {
      await dispatch(forgotPassword(data.email))
    },
    [dispatch]
  )

  const ForgotPasswordAlert = useCallback(() => {
    if (task !== 'forgotPassword') return null

    if (status === 'failed')
      return (
        <Alert status="error">
          <AlertIcon />
          <AlertDescription>{errors[0].message}</AlertDescription>
        </Alert>
      )
    else if (status === 'succeeded')
      return (
        <Alert status="success">
          <AlertIcon />
          <AlertDescription>
            <Text noOfLines={3} wordBreak="break-word">
              Password reset instructions have been sent to:
              <br />
              <strong>{email}</strong>.
            </Text>
          </AlertDescription>
        </Alert>
      )

    return null
  }, [email, errors, status, task])

  return (
    <Stack spacing="6">
      <ForgotPasswordAlert />
      <Stack hidden={status === 'succeeded'} as="form" spacing="4" onSubmit={handleSubmit(onSubmit)} noValidate>
        <FormControl isRequired isInvalid={formState.errors.email}>
          <Input
            autoFocus
            type="email"
            placeholder="Enter your email"
            {...register('email', { validate: validators.email })}
          />
          <FormErrorMessage>{formState.errors?.email?.message}</FormErrorMessage>
        </FormControl>
        <Button type="submit" isLoading={status === 'loading'}>
          Reset Password
        </Button>
      </Stack>
      <Link size="sm" as={NavLink} to="/login">
        Return to Sign In
      </Link>
    </Stack>
  )
}
